export default function SocialBox(props){
    return(
        <a href={ props.link } target='_blank' rel='noreferrer' style={ {textDecoration: 'none'} }>
            <div className='social-box'>
                <div className='social-box__icon'> { props.icon }</div>
                <div className='social-box__name'> { props.name }</div>
            </div>
        </a>
    );
}